import { SuccessData } from 'types/api';
import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';
import { UserSuggestion } from '../types';
import { uploadMutations } from 'entities/modules/uploads';

type CreateSuggestionParams = Pick<UserSuggestion, 'text' | 'title'> & {
  files: File[];
};

export const userSuggestionMutations = getMutations({
  createSuggestion: {
    action: async ({ files, ...payload }: CreateSuggestionParams): Promise<UserSuggestion> => {
      const filePayload = await uploadMutations.multiFileUpload.action({
        files,
        prefix: 'feedback',
      });

      return executeApiCall({
        path: '/feedback/suggestions',

        payload: {
          ...payload,
          ...filePayload,
        },
      });
    },
  },

  toggleSuggestionUpvote: {
    action: async (payload: { id: string }): Promise<SuccessData> => {
      return executeApiCall({
        path: '/feedback/suggestions/upvote',

        payload,
      });
    },

    messages: {
      suppressSuccess: true,
    },
  },
});
